export default {
  'utils-enum': {
    url: '/nop/common/enum',
    method: 'get'
  },
  'get-upload-params': {
    url: "/nop/common/upload",
    method: "get"
  },
  // 公司信息接口，菜单下拉功能
  'user-info': {
    url: '/nop/user/actions/get',
    method: 'get'
  },
 
}



// WEBPACK FOOTER //
// ./src/api/utils.js